// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-zyzxx-index-main_right_content-2V-k3","table":"components-zyzxx-index-table-1mOOU"};


//////////////////
// WEBPACK FOOTER
// ./components/zyzxx/index.css
// module id = 2336
// module chunks = 0